<template>
  <card>
    <template slot="header">
      <h4 class="card-title">{{ $t("dashboard.export_title") }}</h4>
      <p class="card-category text-muted border-bottom pb-4">{{ $t("dashboard.export_subtitle") }}</p>
    </template>
    <div class="container py-4">
      <div class="row">
        <div class="col-5">
          <label for="datepicker-from">{{ $t("dashboard.start_date") }}</label>
          <b-form-datepicker
            id="datepicker-from"
            v-model="date_from"
            :max="max_date"
            class=""
            :dark=true
            :placeholder="$t('dashboard.select_date')"></b-form-datepicker>
        </div>
        <div class="col-5">
          <label for="datepicker-to">{{ $t("dashboard.end_date") }}</label>
          <b-form-datepicker
            id="datepicker-to"
            v-model="date_to"
            :max="max_date"
            class=""
            :dark=true
            :placeholder="$t('dashboard.select_date')"></b-form-datepicker>
        </div>
        <div class="col-2 align-self-end ml-auto">
          <button class="btn btn-primary mb-2"  @click="exportAction">{{ $t("dashboard.export") }}</button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-3">
          <div class="form-check">
            <input class="form-check-input" type="radio" name="flexRadioDefault" v-model="exportType" value="repairs" id="flexRadioDefault1" checked>
            <label class="form-check-label" for="flexRadioDefault1">
              Reparos
            </label>
          </div>
        </div>
        <div class="col-md-3">
           <div class="form-check">
            <input class="form-check-input" type="radio" name="flexRadioDefault"  v-model="exportType" value="parts" id="flexRadioDefault2">
            <label class="form-check-label" for="flexRadioDefault2">
              Peças
            </label>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import $http from "@/helpers/api";
export default {
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);

    return {
      exportType: 'repairs',
      exportData: [],
      date_from: "",
      date_to: "",
      max_date: maxDate,
      msg: ""
    };
  },
  console: () => console,
  mounted() {
    // $http.get("/export/repairs").then(resp => {
    //   this.exportData = {
    //     data: resp.data
    //   }
    //   // console.log(this.exportData.data);
    // });
    
  },
  methods: {
    getCurrentDate(){
      var myDate = new Date();
      var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var day = ('0' + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + '-' + month + '-' + day;
    },
    verifyDates(){
      if(this.date_from == "" || this.date_to == ""){
        this.notify(this.$t('dashboard.message.no_dates'));
        return false;
      }

      let date_from = new Date(this.date_from);
      let date_to = new Date(this.date_to);
      if(date_from.getTime() > date_to.getTime()){
        this.notify(this.$t('dashboard.message.end_date_greater'));
        return false;
      }

      let today = new Date(this.getCurrentDate());
      if(date_to.getTime() > today.getTime()){
        this.notify("End Date must not be greater than Today's Date");
        return false;
      }
      
      return true;
    },
    notify(msg){
      this.$notify({
        type: "danger",
        horizontalAlign: "center",
        message: msg
      });
    },
    exportAction(){
      if (this.exportType != 'repairs') {
        this.exportByParts();
      }
      else {
         this.exportAll();
      }
    },
    exportByParts(){
      if(this.verifyDates()){
        const tHeader = [
          'PN',
          'NOME DA PEÇA',
          'QUANTIDADE',
          'TIPO',
          'STATUS',
          'ÚLTIMA ATUALIZAÇÃO'
        ];  // Set the title of the first row of Excel table
        const filterVal = [
          'PN',
          'NOME DA PEÇA',
          'QUANTIDADE',
          'TIPO',
          'STATUS',
          'ÚLTIMA ATUALIZAÇÃO'
        ]; // index, nickName and name are properties of objects in tableData
        let filename = 'CL_'+ this.getCurrentDate().replace('-', '').replace('-', '') + '_' + this.date_from.replace('-', '').replace('-', '') + '-' + this.date_to.replace('-', '').replace('-', '');
        this.export2ExcelMultipleSheet("/export/repairs/parts", this.date_from, this.date_to, filename, tHeader, filterVal);
      }
    },
    exportAll(){
      if(this.verifyDates()){
        const tHeader = [
          'AT',
          'NOME',
          'OS',
          'OS AT',
          'MODELO',
          'Nº SÉRIE',
          'REPAROS EM 90 DIAS',
          'ERRO REPORTADO',
          'TIPO DE RECEBIMENTO',
          'DATA ENTRADA',
          'DATA CONCLUSÃO',
          'DATA RETIRADA',
          'DATA DE INICIALIZAÇÃO (EEPROM)',
          'TOTAL DE PAGINAS IMPRESSAS (EEPROM)',
          'TINTA ORIGINAL?',
          'AVALIAÇÃO TECNICA',
          'DESCRICAO DO REPARO',
          'CÓD PEÇA UTILIZADAS NO REPARO',
          'QTD PEÇA UTILIZADAS NO REPARO',
          'ESTOQUE CANON',
          'QTD ESTOQUE CANON',
          'ESTOQUE AT',
          'QTD ESTOQUE AT',
          "PEÇAS NO REPARO",
          "TEMPO DE REPARO SEM PEÇA (DIAS)",
          "TEMPO DE REPARO COM PEÇA (DIAS)",
          "TEMPO DE DIAGNÓSTICO (DIAS)",
          'RESULTADO',
          'GAR/FORA',
          'GAR/FORA POR PEÇA',
          'OBSERVAÇÕES',
          'STATUS',
          'CIDADE',
          'ESTADO'
        ];  // Set the title of the first row of Excel table
        const filterVal = [
          'AT',
          'NOME',
          'OS',
          'OS AT',
          'MODELO',
          'Nº SÉRIE',
          'REPAROS EM 90 DIAS',
          'ERRO REPORTADO',
          'TIPO DE RECEBIMENTO',
          'DATA ENTRADA',
          'DATA CONCLUSÃO',
          'DATA RETIRADA',
          'DATA DE INICIALIZAÇÃO (EEPROM)',
          'TOTAL DE PAGINAS IMPRESSAS (EEPROM)',
          'TINTA ORIGINAL?',
          'AVALIAÇÃO TECNICA',
          'DESCRICAO DO REPARO',
          'CÓD PEÇA UTILIZADAS NO REPARO',
          'QTD PEÇA UTILIZADAS NO REPARO',
          'ESTOQUE CANON',
          'QTD ESTOQUE CANON',
          'ESTOQUE AT',
          'QTD ESTOQUE AT',
          "PEÇAS NO REPARO",
          "TEMPO DE REPARO SEM PEÇA (DIAS)",
          "TEMPO DE REPARO COM PEÇA (DIAS)",
          "TEMPO DE DIAGNÓSTICO (DIAS)",
          'RESULTADO',
          'GAR/FORA',
          'GAR/FORA POR PEÇA',
          'OBSERVAÇÕES',
          'STATUS',
          'CIDADE',
          'ESTADO'
        ]; // index, nickName and name are properties of objects in tableData
        let filename = 'CL_'+ this.getCurrentDate().replace('-', '').replace('-', '') + '_' + this.date_from.replace('-', '').replace('-', '') + '-' + this.date_to.replace('-', '').replace('-', '');
        this.export2Excel("/export/repairs/all", this.date_from, this.date_to, filename, tHeader, filterVal);
      }
    },
    export2Excel(url, date_from, date_to, filename, tHeader, filterVal) {
      $http.get(url+'/'+date_from+'/'+date_to).then(resp => {
        this.exportData = {
          data: resp.data
        }
        // console.log(this.exportData.data);
        import('@/excel/Export2Excel').then(excel => {
          // console.log(this.exportData.data);
          const list = this.exportData.data;  //Save tableData in data to list
          const data = this.formatJson(filterVal, list);

          excel.export_json_to_excel({
            header: tHeader, //Header Required
            data, //Specific data Required
            filename: filename, //Optional
            autoWidth: true, //Optional
            bookType: 'xlsx' //Optional
          })
        })
      });
      
    },
    export2ExcelMultipleSheet(url, date_from, date_to, filename, tHeader, filterVal) {
      $http.get(url+'/'+date_from+'/'+date_to).then(resp => {
        this.exportData = {
          data: resp.data
        }

        // console.log(this.exportData.data);
        import('@/excel/Export2Excel').then(excel => {
          // console.log(this.exportData.data);
          const list = this.exportData.data;  //Save tableData in data to list

            var sheetNames = [],
            dataV = [],
            headerList = [],
            autoList = [];

            for (var property in list) {

              if ( ! list.hasOwnProperty(property)) {
                  continue;
              }

              sheetNames.push(property);
              dataV.push(list[property]);
              headerList.push(tHeader);
              autoList.push(true)
            }

          excel.export_json_to_multisheet_excel({
            headerList: headerList, //Header Required
            dataList: dataV, //Specific data Required
            filename: filename, //Optional
            sheetnameList: sheetNames,
            autoWidthList: autoList
            // bookType: 'xlsx' //Optional
          })
        })
      });
      
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
};
</script>
